// extracted by mini-css-extract-plugin
module.exports = {"selector":"styles_selector__2mtY3","option":"styles_option__3rFR9","selected":"styles_selected__UZWDZ"};